// extracted by mini-css-extract-plugin
module.exports = {"newsList":"NewsHonorList_newsList__1j0nn","front":"NewsHonorList_front__1DceW","back":"NewsHonorList_back__2Olzg"};